import { useNavigate, useParams, useLocation } from "react-router-dom";
import ReportCard from '../../../components/reportCard/ReportCard';
import Sidebar from '../../../components/sidebar/Sidebar';
import NavBar from '../../../components/navbar/NavBar';

const ReportList = () => {
  const navigate = useNavigate();
  const { url, category  } = useParams();
  const location = useLocation();
  let data =  location.state;

  const reports = [
    ...new Map(
      data
        .filter(r => (r.PARENT_NAME || '').toLowerCase() == url &&
        (r.CATEGORY_NAME.toLowerCase() == category))
        .map(obj => [obj.REPORT_NAME, obj])
    ).values()
  ];

    const handleClick = (report) => {
      navigate( `/reportslanding/${url}/${category}/${report.URL}`,{ 
        state: { reportName: report.REPORT_NAME, reportId: report.REPORT_ID }
      });
  };

  return (
    <div className='LandingPage'>
      <div className="LandingPageContainer">
        <NavBar/>
        <Sidebar/>
        <div className="trackingLandingpageContent">
          <div className="reportLandingTitle">
            <h1>Reports</h1>
          </div>
          <div className="reportLandingReports">
          {reports.map(report =>
            <ReportCard
              key={report.REPORT_ID}
              title={report.REPORT_NAME}
              onClick={() => handleClick(report)}
            />
          )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReportList